/* eslint-disable */
export default (value) => {

  for (let $i = 0; $i < 10; $i++) {
    const textWithoutUnderscore = value.split(`_${$i}`).join('');
    console.log(textWithoutUnderscore)
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/filter/icon-filter.js